module.exports = {"130628001":"高阳县锦华街道","130628101":"庞口镇","130628102":"西演镇","130628103":"邢家南镇","130628104":"晋庄镇","130628105":"小王果庄镇","130628106":"蒲口镇","130628107":"庞家佐镇","130628400":"高阳县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130628.json
// module id = 248
// module chunks = 0